var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.61014C1.5 5.18338 1.84596 4.83742 2.27273 4.83742H17.7273C18.154 4.83742 18.5 5.18338 18.5 5.61014V18.9011C18.5 19.3278 18.154 19.6738 17.7273 19.6738H2.27273C1.84596 19.6738 1.5 19.3278 1.5 18.9011V5.61014Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.63557H18.5V8.44509H1.5V7.63557Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4549 6.47855C17.4549 6.70209 17.2737 6.88331 17.0501 6.88331C16.8266 6.88331 16.6454 6.70209 16.6454 6.47855C16.6454 6.25501 16.8266 6.07379 17.0501 6.07379C17.2737 6.07379 17.4549 6.25501 17.4549 6.47855Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3734 6.47855C16.3734 6.70209 16.1922 6.88331 15.9687 6.88331C15.7451 6.88331 15.5639 6.70209 15.5639 6.47855C15.5639 6.25501 15.7451 6.07379 15.9687 6.07379C16.1922 6.07379 16.3734 6.25501 16.3734 6.47855Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2912 6.47855C15.2912 6.70209 15.1099 6.88331 14.8864 6.88331C14.6628 6.88331 14.4816 6.70209 14.4816 6.47855C14.4816 6.25501 14.6628 6.07379 14.8864 6.07379C15.1099 6.07379 15.2912 6.25501 15.2912 6.47855Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7841 4.80767L13.6419 4.80767L8.78475 13.7124L5.08221 15.6215L4.73825 11.6888L8.7841 4.80767Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0251 2.35182L13.3879 3.6877L8.04432 13.1389L5.52704 14.8338L5.68152 11.803L11.0251 2.35182Z",
    fill: "#888888"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9007 0.705623C12.0107 0.511028 12.2576 0.442466 12.4522 0.552487L14.1103 1.48995C14.3049 1.59997 14.3735 1.84691 14.2635 2.04151L13.5721 3.26436L11.2093 1.92848L11.9007 0.705623Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemes);
export default __webpack_public_path__ + "static/media/themes.ce7fd66a252a9613229410462ba44f45.svg";
export { ForwardRef as ReactComponent };